import React, { useState } from "react";
import BaseModal from "../../../components/BaseModal";
import ShowToast from "components/ShowToast";
import { useSession } from "hooks/useSession";

export default function LoadWalletPayThroughUpi({ show, onClose, title }) {
  const [errors, setErrors] = useState({});
  const {userid} = useSession();

  const validateAmount = (amount) => {
    let newErrors = {};
    if (!amount) {
      newErrors.amount = "Amount is required.";
    } else if (!/^\d+(\.\d{1,2})?$/.test(amount)) {
      newErrors.amount = "Amount must be a valid number.";
    } else {
      const numAmount = parseFloat(amount);
      if (numAmount < 1) {
        newErrors.amount = "Amount must be higher than 1.";
      } else if (numAmount > 200000) {
        newErrors.amount = "Amount must be lower than 200001.";
      }
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSave = async () => {
    const amount = +document.getElementById("amount").value.trim();

    if (!validateAmount(amount)) {
      return;
    }

    const submitData = new FormData();
    submitData.append("amount", amount);
    submitData.append("userid", userid);
    try {
      const response = await fetch(
        "https://pro.mokshiq.in/create_order_wallet_topup",
        {
          method: "POST",
           headers: {
          'Authorization': `Bearer ${localStorage.getItem("authToken")}`,
        },
          body: submitData,
        }
      );
      if (!response.ok) {
        ShowToast("Something went wrong", "danger");
        console.error("Network error");
        onClose();
        return;
      }

      const result = await response.json();
      if (result.status) {
        console.log("Success:", result.data || "Amount loaded successfully!");
        onClose();
      } else {
        console.error("Error:", result.data || "Something went wrong!");
      }
    } catch (error) {
      console.error("Request failed:", error);
    }
  };

  const handleAmountChange = (e) => {
    const value = e.target.value;
    // Only allow numbers and decimal point
    const numericValue = value.replace(/[^0-9.]/g, "");

    // Prevent multiple decimal points
    const parts = numericValue.split(".");
    if (parts.length > 2) {
      e.target.value = parts[0] + "." + parts.slice(1).join("");
      return;
    }

    // Limit decimal places to 2
    if (parts[1] && parts[1].length > 2) {
      e.target.value = parts[0] + "." + parts[1].substring(0, 2);
      return;
    }

    e.target.value = numericValue;

    // Clear error when user starts typing
    if (errors.amount) {
      setErrors({});
    }
  };

  return (
    <BaseModal
      show={show}
      onClose={onClose}
      title={title}
      footerButtons={[
        { label: "Close", className: "btn-secondary", dismiss: true },
        {
          label: "Load Wallet",
          className: "btn-primary",
          type: "submit",
          form: "wallet-form",
          onClick: handleSave,
        },
      ]}
    >
      <div className="card-body">
        <form
          className="row g-3 app-form rounded-control"
          id="wallet-form"
          onSubmit={handleSave}
        >
          <div className="col-12">
            <label className="form-label" htmlFor="amount">
              Amount <span className="text-danger">*</span>
            </label>
            <div className="input-group">
              <span className="input-group-text">₹</span>
              <input
                className={`form-control ${errors.amount ? "is-invalid" : ""}`}
                id="amount"
                name="amount"
                type="text"
                placeholder="Enter amount (1 - 200000)"
                onChange={handleAmountChange}
                onKeyDown={(e) => {
                  // Prevent non-numeric characters except decimal point
                  if (
                    !/[0-9.]/.test(e.key) &&
                    e.key !== "Backspace" &&
                    e.key !== "Delete" &&
                    e.key !== "Tab"
                  ) {
                    e.preventDefault();
                  }
                }}
                inputMode="decimal"
                pattern="[0-9]*[.]?[0-9]*"
              />
            </div>
            {errors.amount && (
              <div className="text-danger mt-1 f-s-12">{errors.amount}</div>
            )}
            <small className="form-text text-muted">
              Enter amount between ₹1 and ₹200,000
            </small>
          </div>
        </form>
      </div>
    </BaseModal>
  );
}
